import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { offerFilter, offerList } from 'src/app/modules/offers/models/offer.model'
import { offerMethod, offerType } from 'src/app/modules/offers/models/offers.enum'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'

@Component({
	selector: 'app-offers-table',
	templateUrl: './offers-table.component.html',
	styleUrls: ['./offers-table.component.scss'],
})
export class OffersTableComponent implements OnInit {
	@Input() offers: offerList[] = []
	@Input() offerFilter!: offerFilter
	@Input() totalCount!: number
	@Output() deleteId = new EventEmitter<number>()
	@Output() toggleChange = new EventEmitter<any>()
	offerType: any = offerType
	offerMethod: any = offerMethod
	constructor(public translate: TranslateService, private dialog: MatDialog) {}

	ngOnInit(): void {}
	openDialog(id: number) {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '585px',
				data: {
					notflex: true,
					image: `assets/images/danger.png`,
					message: `CONFIRMATION_MESSAGE.DELETE_OFFER`,
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: `ACTIONS.DELETE`,
					confirmBtnStyle: `text-off-white bg-red-error`,
					cancelBtnStyle: ` border-[1px] border-secondry-color-Gray text-dark-grey border-solid`,
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.deleteId.emit(id)
					}
				},
			})
	}
}
